import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link 
      to="/" 
      style={{ 
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      }}
    >
      <img 
        src="/logo.png" 
        alt="ESN Publications Logo"
        style={{
          width: '60px',
          height: '60px',
          objectFit: 'contain'
        }}
      />
      <div>
        <div style={{
          fontSize: '1.6rem',
          fontWeight: 700,
          color: 'var(--text-primary)',
          lineHeight: 1
        }}>
          ESN Publications
        </div>
        <div style={{
          fontSize: '0.9rem',
          color: 'var(--text-secondary)',
          lineHeight: 1
        }}>
          Research and Development
        </div>
      </div>
    </Link>
  );
};

export default Logo;